import React from 'react';

export default function CommandGatewayIcon({ className = '', ...props }) {
  const imageProps = { ...props };
  delete imageProps.strokeWidth;

  return (
    <img
      src="/assets/rely-command-core-icon.webp"
      alt=""
      width="256"
      height="256"
      draggable="false"
      className={`object-cover ${className}`.trim()}
      {...imageProps}
    />
  );
}
